module.exports = __webpack_public_path__ + "static/media/centerlogo.978e84c5.svg";